export default {
    slotCount: 3,
    defaultPositions: [12, 5, 20],
    solution: ["lovers", "death", "hangedMan"]
}